var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"as-button-line",class:{
    'as-button-line--white': _vm.variant === 'white',
    'as-button-line--purple-hover': _vm.hoverEffect
  }},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }